import { render, staticRenderFns } from "./NormalImg1.vue?vue&type=template&id=72f74ae6"
import script from "./NormalImg1.vue?vue&type=script&lang=js"
export * from "./NormalImg1.vue?vue&type=script&lang=js"
import style0 from "./NormalImg1.vue?vue&type=style&index=0&id=72f74ae6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports